function initIframesResizable(collection, breakpoint)
{
    resizeIframes(collection, breakpoint);
    showIframes(collection);
    initIframesBehaviour(collection, breakpoint);
}

function initIframesBehaviour(collection, breakpoint)
{
    $(window).resize(function()
    {
        resizeIframes(collection, breakpoint);
    });
}

function resizeIframes(collection, breakpoint)
{
    collection.each(function()
    {
        var iframe = $(this);
        var iframeContainer = iframe.parent();

        var containerWidth = iframeContainer.width();
        var containerHeight = containerWidth / 16 * 9; // calculamos en alto en base a la proporción 16:9 si el contenedor es responsive

        if(breakpoint != undefined && Modernizr.mq('(min-width:' + breakpoint + 'px)'))
        {
            containerHeight = iframeContainer.height(); // si hay un punto de ruptura a partir del cual el alto se da por css, no se calcula
        }

        iframe.width(containerWidth);
        iframe.height(containerHeight);
    });
}

function showIframes(collection)
{
    collection.css('visibility', 'visible');
}
